import React from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <section className="hero">
        <div className="hero-content">
          <h1>Secure, Private Voting with Zero-Knowledge Proofs</h1>
          <p className="hero-subtitle">
            Create elections, cast encrypted votes, and verify results - all while preserving privacy.
          </p>
          <div className="hero-actions">
            <Link to="/elections" className="btn btn-primary">View Elections</Link>
            <Link to="/elections/create" className="btn btn-outline">Create Election</Link>
          </div>
        </div>
      </section>

      <section className="features">
        <h2 className="section-title">How zkVox Works</h2>
        
        <div className="feature-grid">
          <div className="feature-card">
            <div className="feature-icon">🔒</div>
            <h3>End-to-End Encryption</h3>
            <p>All votes are encrypted using ElGamal encryption on elliptic curves, ensuring only the final tally is revealed.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🧮</div>
            <h3>Homomorphic Properties</h3>
            <p>Votes can be tallied while remaining encrypted, preserving voter privacy throughout the process.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">✓</div>
            <h3>Zero-Knowledge Proofs</h3>
            <p>Verify the correctness of the voting process without revealing individual votes.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🗳️</div>
            <h3>Multiple Election Types</h3>
            <p>Support for single choice, multi-choice, and ranked voting systems.</p>
          </div>
        </div>
      </section>

      <section className="cta">
        <h2>Ready to Start?</h2>
        <p>Create an election and experience secure, privacy-preserving voting today.</p>
        <Link to="/elections/create" className="btn btn-primary">Create Election</Link>
      </section>
    </div>
  );
};

export default HomePage;